import { LessonsProjectOperation } from '../models/lessons-project-list';

export const LESSONS_LOADING_ERROR_OPERATIONS: LessonsProjectOperation[] = [
  'fetchProjectById',
  'fetchQuestionSets',
  'getLessonsCatalog',
];
export const LESSON_DRAFT_ERROR_OPERATIONS: LessonsProjectOperation[] = [
  'fetchDraft',
  'postLesson',
];

export const LESSONS_SAVED_ERROR_OPERATIONS: LessonsProjectOperation[] = [
  'getLessonSaved',
  'fetchQuestionsSelectedForm',
];
